<nav class="snb" data-testid="side-navbar-container" [class.collapsed]="isCollapsed" (mouseleave)="onMouseLeave()">
	<!-- Brand header -->
	<div class="snb-brand">
		<a class="snb-brand-link" data-testid="side-navbar-link-home" [routerLink]="['']">
			<img class="snb-brand-star" src="../../../../assets/images/Gold Star_2500px.png" alt="TRB Goldstar" data-testid="side-navbar-img-logo" />
		</a>
		<div class="snb-brand-text" [hidden]="isCollapsed">
			<span class="snb-brand-trb">TRB</span>
			<span class="snb-brand-sub">Goldstar</span>
		</div>
		<button class="snb-collapse-btn" data-testid="side-navbar-btn-toggle-collapse" [matTooltip]="isCollapsed ? 'Expand' : 'Collapse'" matTooltipPosition="right" (click)="toggleCollapse()">
			<mat-icon class="material-icons-outlined snb-collapse-icon">{{ isCollapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
		</button>
	</div>

	<!-- Loading state -->
	@if (loading) {
		<div class="snb-loading" data-testid="side-navbar-panel-loading">
			<span class="snb-loading-text">Loading...</span>
		</div>
	}

	<!-- Search bar -->
	@if (!loading) {
		@if (isCollapsed) {
			<button class="snb-search-collapsed-btn" data-testid="side-navbar-btn-search-expand" matTooltip="Search" matTooltipPosition="right" (click)="expandAndFocusSearch()">
				<i class="bx bx-search bx-xs"></i>
			</button>
		} @else {
			<div class="snb-search" data-testid="side-navbar-container-search">
				<input #searchInput class="snb-search-input" data-testid="side-navbar-input-search" placeholder="Search menu..." [(ngModel)]="searchTerm" (keyup)="onSearchKeyUp()" />
				<span class="snb-search-icon">
					@if (!searchInProgress) {
						<i class="bx bx-search bx-xs"></i>
					}
					@if (searchInProgress) {
						<i class="bx bx-x bx-xs" data-testid="side-navbar-btn-clear-search" (click)="clearSearch()"></i>
					}
				</span>
			</div>
		}
	}

	<!-- Navigation groups -->
	@if (!loading) {
		<div class="snb-nav" data-testid="side-navbar-nav-menu">
			@for (group of filteredGroups; track group.id) {
				<div class="snb-nav-group">
					<!-- Group header — click to expand/collapse -->
					<button
						class="snb-group-header"
						[class.expanded]="expandedGroups.has(group.id)"
						[class.group-active]="activeGroupIds.has(group.id)"
						[attr.data-testid]="'side-navbar-btn-group-' + group.id"
						[matTooltip]="group.label"
						[matTooltipDisabled]="!isCollapsed"
						matTooltipPosition="right"
						(click)="toggleGroup(group)"
					>
						@if (group.icon) {
							<i class="bx snb-item-icon" [ngClass]="group.icon"></i>
						}
						<span class="snb-group-label">{{ group.label }}</span>
						<mat-icon class="material-icons-outlined snb-chevron" [class.rot]="expandedGroups.has(group.id)">chevron_right</mat-icon>
					</button>

					<!-- Group items — visible only when group is expanded -->
					@if (expandedGroups.has(group.id)) {
						<div class="snb-group-items">
							@for (item of group.items; track item.id) {
								<div class="snb-nav-item-wrapper">
									<button
										class="snb-item"
										[class.active]="activeId === item.id"
										[class.parent-active]="parentActiveIds.has(item.id)"
										[class.open]="expandedItems.has(item.id)"
										[attr.data-testid]="'side-navbar-btn-' + item.id"
										(click)="onItemClick(item)"
									>
										<span class="snb-item-label">{{ item.label }}</span>
										<mat-icon
											class="snb-favorite-icon"
											[class.is-favorite]="item.isFavorite"
											[attr.data-testid]="'side-navbar-btn-favorite-' + item.id"
											(click)="onFavoriteToggle(item, $event)"
										>
											{{ item.isFavorite ? 'star' : 'star_border' }}
										</mat-icon>
										@if (item.badge) {
											<span class="snb-badge" [class.active-badge]="activeId === item.id">{{ item.badge }}</span>
										}
										@if (item.children?.length) {
											<mat-icon class="material-icons-outlined snb-chevron" [class.rot]="expandedItems.has(item.id)">chevron_right</mat-icon>
										}
									</button>

									@if (item.children?.length && expandedItems.has(item.id)) {
										<div class="snb-sub">
											@for (child of item.children; track child.id) {
												<button class="snb-subitem" [class.active]="activeId === child.id" [attr.data-testid]="'side-navbar-btn-' + child.id" (click)="onSubItemClick(child)">
													<span>{{ child.label }}</span>
												</button>
											}
										</div>
									}
								</div>
							}
						</div>
					}
				</div>
			}
		</div>
	}
</nav>
